export default Object.freeze({
  CalendarFindMeetingTimes: 1,
  CalendarCreateMeeting: 2,
  CalendarDeleteMeeting: 3,
  EmailGetMessage: 4,
  EmailSubscribeNewMessages: 5,
});
